import { ApplicationLightResult, CurrentApplicationUserRolesResult, DataSynthesis } from "../generated/UsedGeneratedTypes";
import { LocalApplication } from "./LocalApplication";

export class LocalApplicationLightResult implements ApplicationLightResult {
  dataSyntheses: DataSynthesis[];
  application: LocalApplication;
  currentApplicationUserRolesResult: CurrentApplicationUserRolesResult;
  hasSignedCharte: boolean;
  hasSignedLastCharte: boolean;

  constructor(applicationLightResult: ApplicationLightResult) {
    this.dataSyntheses = applicationLightResult.dataSyntheses;
    this.application = { ...applicationLightResult.application, localName: applicationLightResult.application.name, localDescription: "" };
    this.currentApplicationUserRolesResult = applicationLightResult.currentApplicationUserRolesResult;
    this.hasSignedCharte = applicationLightResult.hasSignedCharte;
    this.hasSignedLastCharte = applicationLightResult.hasSignedLastCharte;
  }
}
